module.exports = __webpack_public_path__ + "static/media/d50774bb2e181f81cdca8cd3d635e4dd_html_1a6ef8ee1e98ee27.2fe28c8c.png";